import React from 'react';
import './VotingMarker.css';

export function VotingMarker({ submission, position, onVote, isAuthenticated, isSelected, onSelect }) {

  const getPriceColor = (price) => {
    // Simple color scale from blue (cheap) to red (expensive)
    if (price < 200000) return '#2196F3';
    if (price < 400000) return '#4CAF50';
    if (price < 600000) return '#FFC107';
    if (price < 800000) return '#FF9800';
    return '#F44336';
  };

  const formatPrice = (price) => {
    return '£' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const formatPriceShort = (price) => {
    const priceInK = Math.round(price / 1000);
    return `£${priceInK}k`;
  };

  const getTooltipText = () => {
    const parts = [formatPrice(submission.price), submission.type, submission.month_year];

    if (submission.total_floor_area) {
      parts.push(`${submission.total_floor_area}m²`);
    }

    if (submission.tenure) {
      parts.push(submission.tenure);
    }

    if (submission.new_build) {
      parts.push('New Build');
    }

    parts.push(`Score: ${score >= 0 ? '+' + score : score}`);

    return parts.join(' • ');
  };

  const score = submission.score || 0;
  const upvotes = submission.upvotes || 0;
  const downvotes = submission.downvotes || 0;

  return (
    <div
      className="voting-marker"
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
    >
      <div
        className="marker-pin"
        style={{ backgroundColor: getPriceColor(submission.price) }}
        onClick={() => onSelect(isSelected ? null : submission.submission_id)}
        title={getTooltipText()}
      >
        {formatPriceShort(submission.price)}
      </div>

      {isSelected && (
        <div className="voting-popup">
          <button className="close-popup" onClick={() => onSelect(null)}>×</button>

          <div className="popup-info">
            <strong>{formatPrice(submission.price)}</strong>
            <div>{submission.month_year}</div>
            <div>{submission.type}</div>
          </div>

          <div className="vote-score">
            <span>👍 {upvotes}</span>
            <span>|</span>
            <span>👎 {downvotes}</span>
            <span>|</span>
            <span>Score: {score}</span>
          </div>

          {isAuthenticated ? (
            <div className="vote-buttons">
              <button
                className="vote-btn upvote"
                onClick={() => {
                  onVote(submission.submission_id, 1);
                  onSelect(null);
                }}
              >
                👍 Verify
              </button>
              <button
                className="vote-btn downvote"
                onClick={() => {
                  onVote(submission.submission_id, -1);
                  onSelect(null);
                }}
              >
                👎 Flag
              </button>
            </div>
          ) : (
            <div style={{ fontSize: '12px', color: '#666', textAlign: 'center', marginTop: '8px' }}>
              Log in to vote
            </div>
          )}
        </div>
      )}
    </div>
  );
}
